import { Grid2 as Grid } from "@mui/material";
import { GridApi, GridReadyEvent } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import { useGridStyles } from "../../styles/gridStyles";
import { useGroupedTableData } from "../hooks/useTableData";
import { FailedStartupGrouped } from "../models/FailedStartupHeat";

type Props = {
	rows: FailedStartupGrouped[];
	isLoading: boolean;
	gridRef: React.RefObject<AgGridReact>;
};

export const FailedStartupGroupedTable = ({
	isLoading,
	gridRef,
	rows,
}: Props) => {
	const [gridAPI, setGridAPI] = useState<GridApi | null>(null);
	const { columnData } = useGroupedTableData();

	const onGridReady = (params: GridReadyEvent) => {
		setGridAPI(params.api);
	};

	useEffect(() => {
		if (gridAPI) {
			if (isLoading) {
				gridAPI.showLoadingOverlay();
			} else {
				gridAPI.hideOverlay();
				gridAPI.setGridOption("rowData", rows);
			}
		}
	}, [gridAPI, isLoading, rows]);

	return (
		<div style={{ height: "70vh", width: "100%" }}>
			<Grid
				size={{ xs: 12 }}
				style={{
					borderRadius: "0 0 10px 10px",
					height: "calc(100vh - 300px)",
					minHeight: "calc(100vh - 300px)",
					border: "1px solid #E0E0E0",
					borderTop: "none",
				}}
			>
				<div style={{ height: "100%", width: "100%" }}>
					<AgGridReact
						onGridReady={onGridReady}
						rowData={rows}
						columnDefs={columnData}
						rowSelection="single"
						overlayLoadingTemplate={"Loading..."}
						suppressContextMenu={true}
						getRowId={(params) => `${params.data.Year}-${params.data.Month}`}
						ref={gridRef}
					/>
				</div>
			</Grid>
		</div>
	);
};
